import { React, useEffect, useState } from 'react';
import apiService from '../../services/apiServices';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { createTheme } from '@mui/material/styles';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import { Link } from 'react-router-dom';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Contract1 from '../pdfcontracts/Contract1';
import { Bars } from 'react-loader-spinner'
import dateFormats from '../../services/dateFormats';
import { useForm } from 'react-hook-form';
import { jsPDF } from "jspdf";
import DownloadIcon from '@mui/icons-material/Download';

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default function ContractsList() {
  const [workers, setWorkers] = useState([]);
  const [modal, setModal] = useState({});
  const [rowId, setRowId] = useState({});
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(true);
  const [worker, setWorker] = useState([]);
  const [contractDetails, setContractDetails] = useState([]);
  const [contractTemplate, setContractTemplate] = useState()
  const [settings, setSettings] = useState()
  const {
    // register,
    // handleSubmit,
    setValue,
    // control,
    // watch,
    formState: { errors },
  } = useForm();
  const salaryTypes = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Me ore" }]
  const contractExtension = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Vjetore" }]
  const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]
  const workerTags = ["FirstName", "LastName", "ParentName", "PersonalId", "Address", "Phone", "PostalCode", "BankAccount", "BankName", "Birthday", "Country", "Place", "Email", "Gender", "MaritalStatus", "Qualification", "ContractType", "StartDate", "EndDate", "WorkType", "SalaryType", "Department", "BaseSalary", "BrutoNeto", "HourSalary", "HourSalaryWeekend", "HourSalaryHoliday", "Image", "TermsOfContract"]

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const replaceText = (contractTemplate, employee) => {
    let text = contractTemplate?.Text;
    let data = Object.assign(employee, employee?.Contract)

    workerTags?.forEach((tag, key) => {

      if (tag === 'Image') {
        console.log(tag, imageTag(data[tag.toString()]))
        text = text.replaceAll("@" + tag, data[tag.toString()] ? <img src={data[tag.toString()]} /> : "--");
      }
      else {
        text = text.replaceAll("@" + tag, data[tag.toString()] ? data[tag.toString()] : "--");
      }

    })
    return text;
  }

  const imageTag = (src) => {
    return <img src={src} />
  }

  const toPdf = (fileName, contractTemplate, employee) => {
    setLoader(true)
    var doc = new jsPDF();
    var elementHTML = replaceText(contractTemplate, employee);//document.querySelector("#contnet");

    doc.html(elementHTML, {
      callback: function (doc) {
        doc.save(fileName ? fileName + '.pdf' : 'document.pdf');
        setLoader(false)
      },
      x: 15,
      y: 15,
      width: 170, //target width in the PDF document
      windowWidth: 750 //window width in CSS pixels
    });
  }

  const towordDoc = (filename = '', contractTemplate, employee) => {
    var invoiceBg = settings?.InvoiceBg;
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body style='background: url("+invoiceBg+")'>";
    var footer = "</body></html>";
    var html = header + replaceText(contractTemplate, employee) + footer;
    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    filename = filename ? filename + '.doc' : 'document.docx';
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  }

  const getContractTemplate = (employee) => {
    apiService().query('getTemplate', 'id=' + employee?.Contract?.Template)
      .then(response => {
        if (response.success) {
          towordDoc(employee?.FirstName + "_" + employee?.LastName, response.data[0], employee)
        }
      })
  }

  const getSettings = () => {
    apiService().get("settings").then(response => {
      if (response.success) {
        setSettings(response.data[0])
      }
    })
  }

  useEffect(() => {
    apiService()
      .get('workers')
      .then((response) => {
        if (response.success) {
          let w = response.data;
          //let arr = []
          w.map(e => {
            apiService()
              .query('getWorkerContracts', 'id=' + e.Id)
              .then((wc) => {
                if (wc.success) {
                  e.Contract = wc.data[wc?.data.length - 1]
                  let newArr = [...w];
                  setWorkers(newArr);
                  setLoader(false)
                } else {
                  alert('Error:' + wc.errorMessage);
                }
              });
          })
        } else {
          //alert('Error:' + response.errorMessage);
        }
      });
      getSettings()
  }, []);

  //console.log(workers);
  // return <Contract1 />;
  return (
    <div>
      {loader && <div className="loader-class"><Bars
        height="70"
        width="100%"
        color="#1976d2"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /></div>}
      {!loader && <>
        <Toast {...toast} />
        <TopActions
          // newHref="/workerlist/addworker"
          saveHref="/dashboard/"
          saveVisible="d-none"
        />
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell>Nr</TableCell>
                <TableCell>Emri</TableCell>
                <TableCell>Emri i prindit</TableCell>
                <TableCell>Mbiemri</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Telefoni</TableCell>
                <TableCell>Vendi</TableCell>
                <TableCell>Print</TableCell>
                <TableCell style={{ width: '50px' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((w, index) => (
                  <TableRow key={w.Id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{w.FirstName}</TableCell>
                    <TableCell>{w.ParentName}</TableCell>
                    <TableCell>{w.LastName}</TableCell>
                    <TableCell>{w.Email}</TableCell>
                    <TableCell>{w.Phone}</TableCell>
                    <TableCell>{w.Place}</TableCell>
                    <TableCell>{w.Contract?.Template ? <Button onClick={() => getContractTemplate(w)}><DownloadIcon /></Button> : 'Not selectd contract template'}</TableCell>
                    <TableCell>
                      <ButtonGroup size="small">
                        <Link to={`workerlist/editworkercontract/${w?.Contract?.Id}`}>
                          <Button>
                            <EditIcon />
                          </Button>
                        </Link>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={workers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>}
    </div>
  );
}
